export default function () {
    var {hostname, port, protocol} = location;
    var prefix = '';
    if (process.env.NODE_ENV === 'production') {
        prefix = document.querySelector('meta[name="prefix"]').getAttribute('content')
    }
    // console.log(`${protocol}//${hostname}:${port}/${prefix}`);
    if(process.env.NODE_ENV === 'development'){
        return `http://m-dev.mingyuanyun.com/test`;
    }
    return `${protocol}//${hostname}:${port}/${prefix}`;
}



// WEBPACK FOOTER //
// ./src/api/apiPath.js